import React, {useEffect, useState, useContext} from 'react';
import BodyKnowledgeDescriptionContentSide from '../BodyKnowledgeDescriptionContentSide';
import styled from 'styled-components';
import {createRequestURL, createUpdatePayloadForMultiSelectBody} from '../Common/BodyResponseUtility';
import EllipseControl from '../../../../Common/EllipsesControl/EllipsesControl';
import {DocumentTypeIdContext} from '../../../../Main/Forms/CanvasFormContainer';
import {formBodyType} from '../../../../../util/uiconstants';
import RiskFactorContainer from '../Common/RiskFactorContainer';
import {labels, GetCardTypeForBody} from '../../../../../util/utils';
import ProgressBar from '../../../BaseComponentWrappers/MotifProgressBar';
import ToggleSwitch from '../../../BaseComponentWrappers/MotifToggleSwitch';
import _ from 'lodash';
import {useDocumentId, useEngagementId} from '../../../../../util/customHooks';

export default function ToggleSwitchList(props) {
	const {
		isAresView,
		showGuidance,
		guidanceFilter,
		bodyRelatedData,
		headerId,
		sectionId,
		bodyId,
		updateBodyOptions,
		getBodiesBySectionId,
		isSnapshotView,
		isDisabled
	} = props;

	const engagementId = useEngagementId(),
		documentTypeId = useContext(DocumentTypeIdContext),
		documentId = useDocumentId();

	const [changedResponse, setChangedResponse] = useState(false);
	const [toggleSwitchData, setToggleSwitchData] = useState([]);

	useEffect(() => {
		let bodyData = _.cloneDeep(bodyRelatedData.optionsAndResponses);

		if (bodyData && bodyData.length > 0) {
			let filterBodyData = bodyData.map((obj) => ({
				...obj,
				isChecked: isSnapshotView ? obj.bodySelectedOptionId : obj.bodyOptionId === obj.bodySelectedOptionId
			}));
			setToggleSwitchData(filterBodyData);
		} else {
			setToggleSwitchData([]);
		}
	}, [bodyRelatedData.optionsAndResponses, isSnapshotView]);

	const checkChange = (e) => {
		if (props.isSnapshotView) {
			return;
		}
		const changed = e.currentTarget.id;

		if (toggleSwitchData && toggleSwitchData.length > 0) {
			toggleSwitchData.map((data) => {
				if (data.bodyOptionId === Number(changed)) {
					data.isChecked = !data.isChecked;
				}
			});
			setToggleSwitchData(toggleSwitchData);
			setChangedResponse(!changedResponse);
		}

		const bodyResponseObject = createUpdatePayloadForMultiSelectBody(formBodyType.ToggleSwitch, toggleSwitchData);
		document.getElementById(bodyId).classList.add('greyOutArea');

		updateBodyOptions(
			bodyId,
			changed,
			createRequestURL(engagementId, documentId, headerId, sectionId, bodyId, documentTypeId),
			bodyResponseObject
		);
	};

	const formBodyBorder = GetCardTypeForBody(bodyRelatedData, isAresView);
	return (
		<Wrapper className={`SectionBodyWrapper SectionBodySlider SectionBodyToggleSwitch ${formBodyBorder}`}>
			<StyledToggleSwitchListContainer className="StyledToggleSwitchListContainer">
				<BodyKnowledgeDescriptionContentSide
					isAresView={isAresView}
					isSnapshotView={isSnapshotView}
					bodyModel={bodyRelatedData}
					engagementId={engagementId}
					documentId={documentId}
					headerId={headerId}
					sectionId={sectionId}
					bodyId={bodyId}
					bodyDescriptionText={bodyRelatedData.name}
					isCustom={bodyRelatedData.isCustom}
					isDuplicate={bodyRelatedData.isDuplicate}
					getBodiesBySectionId={getBodiesBySectionId}
					showGuidance={showGuidance}
					guidanceFilter={guidanceFilter}
				>
					{toggleSwitchData.map((obj) => (
						<section className="SectionBodyData ToggleSwitchListBodyData" id={bodyId}>
							<section className="MotifProgressBarWrapper">
								<ProgressBar isIndeterminate showLabel labelComponent={<span>{labels.saving}</span>} />
							</section>
							<section className="ToggleSwitchColumnWrapper">
								<section className="switch-column">
									<ToggleSwitch
										onChange={checkChange}
										checked={obj.isChecked}
										id={!isSnapshotView && obj.bodyOptionId}
										offLabel=""
										onLabel=""
										disabled={isDisabled}
									/>
								</section>
								<section className="options-column">
									<EllipseControl
										content={obj.bodyOptionText}
										tooltip={obj.bodyOptionText}
										noOfLines={1}
										tooltipClass="tooltipCustomWidth"
									/>
								</section>
							</section>
						</section>
					))}
				</BodyKnowledgeDescriptionContentSide>
				{toggleSwitchData.map((obj) => {
					return (
						obj.isChecked &&
						obj.riskFactorList.length > 0 && (
							<RiskFactorContainer
								riskFactors={obj.riskFactorList}
								isVisible
								sectionId={sectionId}
								bodyId={bodyId}
								isViewBodyOnly={false}
							/>
						)
					);
				})}
			</StyledToggleSwitchListContainer>
		</Wrapper>
	);
}

const Wrapper = styled.section`
	display: block;
	&.SectionBodySlider {
		min-height: var(--px-110);
	}
	&.DefaultView {
		.ToggleSwitchListBodyData {
			background-color: var(--neutrals-00white);
			border: var(--px-1) solid var(--neutrals-200);
			border-radius: var(--px-12) !important;
			padding: var(--px-24);
			margin-top: var(--px-24);
			width: 100%;
		}
	}
	.SectionBodyData {
		flex-direction: unset !important;
		padding: 0;
		width: var(--px-300);
		text-align: end;
		position: relative;
		.MotifProgressBarWrapper {
			display: none;
			position: absolute;
			justify-content: center;
			width: 80%;
			height: auto;
			.motif-progress-bar-wrapper {
				height: 100%;
				width: 30%;
				z-index: 1;
				justify-content: center;
				span {
					color: var(--green-500);
					font-size: var(--px-12);
				}
				.motif-progress {
					background-color: var(--green-500);
				}
			}
		}
		.ToggleSwitchColumnWrapper {
			display: flex;
			width: 100%;
			.switch-column {
				display: inline-flex;
				width: 100%;
				line-height: var(--px-24);
				height: var(--px-24);
				margin: 0;
				.motif-toggle-switch-wrapper {
					width: 100%;
					.motif-toggle-switch-off-text,
					.motif-toggle-switch-on-text {
						width: auto;
						max-width: 40%;
					}
					.left-option,
					.right-option {
						width: 100%;
						display: flex;
					}
				}
			}
			.options-column {
				display: inline-flex;
				width: var(--px-230);
			}
		}
	}
`;

const StyledToggleSwitchListContainer = styled.section`
	.SectionBodyDescription {
		display: flex;
		justify-content: space-between;
		.SectionBodyDescriptionWrapper {
			width: calc(100% - var(--px-140)) !important;
			.section-showless-header {
				width: calc(100% - var(--px-300)) !important;
				margin-right: 0;
			}
			.SectionBodyDataWrapper {
				width: var(--px-300) !important;
			}
		}
		.sectionBodyRightIcons {
			width: var(--px-140) !important;
		}
	}
`;

const StyledGuidanceWrapper = styled.section`
	margin-top: var(--px-10);
	display: flex;
	font-size: var(--px-18);
	font-weight: 500;
	line-height: var(--px-22);
`;
